<template>
    <div class="home">
        <div v-for="(item, index) in homeConfig" :key='index'>
            <HomeContentItems class="margion-T-30" :title="item.title" :contentItems="item.items"
                              @cellClick="itemClick"></HomeContentItems>
        </div>

        <div v-if="isInner === 999" v-for="(item, index) in homeConfig" :key='index'>
            <HomeContentItems class="margion-T-30" :title="item.title" :contentItems="item.items"
                              @cellClick="itemClick"></HomeContentItems>
        </div>
        <div v-if="isInner === 999">
            <a-row>
                <a-col :span="12">
                    <Banner></Banner>
                </a-col>
                <a-col :span="11" offset="1">
                    <NotificationBanner :data="noticeArray"></NotificationBanner>
                </a-col>
            </a-row>
            <a-row style="margin-top: 30px">
                <a-col>
                    <HomeContentLInkItems :title="'Operation Center'" :dataArray="linkArray"></HomeContentLInkItems>
                </a-col>
            </a-row>
        </div>
        <!--        <div>{{isInner}}</div>-->
        <router-view/>
    </div>
</template>

<script>
    import HeadrContainer from '@/components/HeadrContainer.vue'
    import HomeContentItems from '@/components/HomeContentItems.vue'
    import Banner from '../../components/Banner'
    import NotificationBanner from '../../components/NotificationBanner'
    import HomeContentLInkItems from '../../components/HomeContentLInkItems'

    export default {
        name: 'Home',
        components: {
            HeadrContainer,
            HomeContentItems,
            Banner,
            NotificationBanner,
            HomeContentLInkItems
        },
        data() {
            return {
                homeConfig: [
                    {
                        title: 'My Request and Task',
                        items: [{title: 'Carrier requests',}, {title: 'Delivery tracking subscriptions',}]
                    }
                ],
                isInner: 1,
                noticeArray: [
                    {
                        title: 'title',
                        content: 'contentcontentcontentcontentcontentcontentcontentcontentcontent'
                    }
                ],
                linkArray: [
                    {
                        link: '',
                        icon: '',
                        title: 'Transportation Planning'
                    },
                    {
                        link: '',
                        icon: '',
                        title: 'Shipment & Event Tracking, Freight Management'
                    },
                    {
                        link: '',
                        icon: '',
                        title: 'Logistics Execution Platform'
                    },
                    {
                        link: '',
                        icon: '',
                        title: 'Logistic Request Management'
                    }
                ]
            }
        },

        created() {
            this.isInner = this.$store.getters.getUserInner ? this.$store.getters.getUserInner : 1
        },
        methods: {
            itemClick(index) {
                if (index === 0) {
                    this.$router.push({
                        path: 'request-list',
                        query: {
                            pageType: '1'
                        }
                    })
                } else if (index === 1) {
                    this.$router.push({
                        path: 'task-list',
                        query: {
                            pageType: '2'
                        }
                    })
                } else if (index === 2) {
                    this.$router.push({
                        path: 'test',
                        query: {
                            pageType: '2'
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    #home {
        .margion-T-30 {
            margin-top: 30px;
        }

        .carrierButton {
            background-color: #d8edcf;
            font-size: 16px;
            font-weight: 600;
            min-height: 80px;
            min-width: 200px;
            text-align: center;
            align-content: center;
            vertical-align: middle;
            line-height: 80px;
            border-radius: 5px;
            color: rgb(47, 101, 46);
        }

        .cfButton {
            background-color: rgb(209, 232, 245);
            min-height: 80px;
            min-width: 200px;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            align-content: center;
            vertical-align: middle;
            line-height: 80px;
            border-radius: 5px;
            color: rgb(39, 93, 124);
        }
    }
</style>
